//venders
import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams, useLocation } from "react-router-dom"
import { useTheme } from "@material-ui/core/styles"
import CardHeader from "@material-ui/core/CardHeader"
import AppBar from "@material-ui/core/AppBar"
import Box from "@material-ui/core/Box"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import Typography from "@material-ui/core/Typography"
import Menu from "@material-ui/core/Menu"
import Container from "@material-ui/core/Container"
import Avatar from "@material-ui/core/Avatar"
import Badge from "@material-ui/core/Badge"
import Tooltip from "@material-ui/core/Tooltip"
import MenuItem from "@material-ui/core/MenuItem"
import MultiBaseDropdownList from "../../build/multiBaseDropdownList/MultiBaseDropdownList"
import BellSVG from "../../icons/BellSVG"
import anzyzLegalLogo from "../../../images/tranlogo_h__y_kvalitet_white_.png"
//css
import "./HeaderStyle.css"
import { getNotification } from "../../../actions/headerActions"
import NotificationView from "./NotificationView"
import { Upload } from "./upload"
import { getUploadFileFormatRequest, getUploadFileStatusRequest } from "../../../actions/uploadActions"
import UserProfileView from "./UserProfileView"
import Notification from "../../Notification/Notification"
import { logoutClearStore, logoutUser, logoutUserAction } from "../../../actions/userActions"
import { clearLocalStorage } from "../../../utils"
import { clearMultibase } from "../../../actions/multiAiBase"

const notifications = ["No Notifications"]

const useStyles = makeStyles((theme) => ({
	customBadge: {
		backgroundColor: theme.palette.primary.dark,
	},
}))

const HeaderView = () => {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles()
	const dispatch = useDispatch()
	let history = useHistory()
	const location = useLocation()
	const [anchorElUser, setAnchorElUser] = useState(null)
	const multiBaseList = useSelector((state) => state.multiBase.multiBaseList)
	const { user } = useSelector((state) => state?.authtentication?.user)
	const isdownloading = useSelector((state) => state.downloads.bulk_download.downloading)
	const isOpen = useSelector((state) => state.upload.isOpen)
	const { loading, passwordChanged } = useSelector((state) => state?.headerReducers)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	//const anzyzLegalLogo = window._env_.REACT_APP_DASHBOARD_LOGO

	const [openUpload, setOpenUpload] = useState(false)

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget)
	}

	const handleCloseUserMenu = () => {
		setAnchorElUser(null)
	}

	useEffect(() => {
		if (passwordChanged) {
			setTimeout(() => {
				handleLogout()
			}, 4000)
		}
	}, [passwordChanged])

	const handleLogout = (e) => {
		dispatch(logoutUserAction())
		dispatch(logoutClearStore())
		dispatch(logoutUser())
		clearLocalStorage()
		dispatch(clearMultibase())
	}

	const MenuProps = {
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left",
		},
		getContentAnchorEl: null,
	}

	const stringAvatar = (name) => {
		return {
			style: {
				...theme?.typography?.avtarText,
				width: "32px",
				height: "32px",
			},
			children: name?.split(" ")[1] ? `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}` : name?.split(" ")[0][0],
		}
	}

	useEffect(() => {
		dispatch(getUploadFileFormatRequest())
		dispatch(getUploadFileStatusRequest())
	}, [selectedBaseId])

	useEffect(() => {
		if (!isOpen) {
			setOpenUpload(false)
		}
	}, [isOpen])

	return (
		<AppBar position="fixed" className="app-bar-header" style={{ background: theme?.palette?.primary?.main }}>
			<Notification />
			<Container maxWidth="false" className="display-flex">
				<Toolbar disableGutters>
					<Box
						component="img"
						style={{
							flex: 1,
						}}
						alt="logo"
						width="134px"
						height="auto"
						src={anzyzLegalLogo}
					/>
				</Toolbar>
				<div className="caseName">
					{!(
						location.pathname.includes("bifrost") ||
						location.pathname.includes("user") ||
						location.pathname.includes("billing")
					) && (
						<>
							<Box style={{ ...theme.typography.subTitle1, color: theme.palette.text.secondary, m: 1 }}>
								{t("header.case_name")}
							</Box>
							<span>&ensp;</span>
							<Box style={{ ...theme.typography.subTitle1, color: theme.palette.text.secondary }}>{"/"}</Box>
							<MultiBaseDropdownList disabled={location.pathname.includes("viewer") || isdownloading} />
						</>
					)}
				</div>
				<Upload open={openUpload} setOpen={setOpenUpload} />
				<NotificationView />
				<Box style={{ ml: 2 }}>
					<UserProfileView />
				</Box>
			</Container>
		</AppBar>
	)
}

export default HeaderView
